import {
  buildEmployeeAmountPipeline,
  buildPayrollAmountLookups,
  sumNumberOrArray,
} from "./shared";

/** tax may be a number or an array of period amounts. */
export const TAX_ROW_AMOUNT = {
  ...sumNumberOrArray("$tax"),
};

export const TAX_LOOKUPS = buildPayrollAmountLookups(
  "tax",
  "tax",
  TAX_ROW_AMOUNT,
);

export function getTaxByEmployeePipeline(employeeIds = []) {
  return buildEmployeeAmountPipeline(employeeIds, "tax", TAX_ROW_AMOUNT);
}
